<template>
    <div class="userParent">
        <div class="userCommon">
            <div class="userCommon_l">
                <ul class="leftUlcenter">
                    <li v-for="(item,index) in menuList" :style="{marginBottom:item.marginBottom}" :key="index">
                        <a v-if="item.title == '会员权益' " @click="jumpEquity">
                            <img v-if="item.url" :src="item.url"/>
                            <div :class="item.url?'lediv':'ridiv'">
                                <div class="gddiv" :style="{color:item.path==pathname||item.url?'#333':'#999'}">{{item.title}}</div>
                                <div v-if="item.path==pathname"
                                     :style="{width:item.title=='法律服务列表'?'83px':item.title=='权利人管理'||item.title=='邀请有好礼' || item.title=='预充值权益'?'70px':'56px'}"
                                     class="active_user"></div>
                            </div>
                        </a>
                        <router-link :to="{path:item.path}" v-else>
                            <img v-if="item.url" :src="item.url"/>
                            <div :class="item.url?'lediv':'ridiv'">
                                <div class="gddiv" :style="{color:item.path==pathname||item.url?'#333':'#999'}">{{item.title}}</div>
                                <div v-if="item.path==pathname"
                                     :style="{width:item.title=='法律服务列表'?'83px':item.title=='权利人管理'||item.title=='邀请有好礼' || item.title=='预充值权益'?'70px':'56px'}"
                                     class="active_user"></div>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="userCommon_r">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
    import Cookies from "js-cookie"; 
    export default {
        name: 'User',
        data() {
            return {
                menuList: [
                    {url: require('@/views/vipClip/user/images/usermenu1.png'), title: '个人中心', marginBottom: "16px"},
                    {title: '会员信息', path: '/memberInfo', marginBottom: "20px"},
                    {title: '我的钱包', path: '/walletPackage', marginBottom: "20px"},
                    {title: '会员权益', path: '/membershipRights', marginBottom: "20px"},
                    {title: '预充值权益', path: '/preRecharge', marginBottom: "50px"},
                    {url: require('@/views/vipClip/user/images/usermenu2.png'), title: '服务中心', marginBottom: "16px"},
                    {title: '我的存证', path: '/myExisting', marginBottom: "16px"},
                    {title: '我的监测', path: '/myMonitor', marginBottom: "20px"},
                    {title: '我的登记', path: '/myDci', marginBottom: "20px"},
                    {title: '我的预登记', path: '/myPre', marginBottom: "20px"},
                    {title: '我的取证', path: '/myEvidence', marginBottom: "20px"},
                    {title: '法律服务列表', path: '/legalOrder', marginBottom: "50px",child:['/legalOrderDetails']},
                    {url: require('@/views/vipClip/user/images/usermenu3.png'), title: '更多', marginBottom: "20px"},
                    {title: '实名认证', path: '/authentication', marginBottom: "20px", child: ['/personalAuthentication','/enterpriseAuthentication1','/enterpriseAuthentication2']},
                    {title: '权利人管理', path: '/obligee', marginBottom: "20px", child: ['/addObligee','/addPersonalObligee','/addEnterpriseObligee']},
                    {title: '邀请有好礼', path: '/inviteFriend', marginBottom: "20px"},
                    {title: '登录历史', path: '/history', marginBottom: "20px"},
                    {title: '消息通知', path: '/messages', marginBottom: "20px"},
                ],
                pathname: window.location.pathname,
            }
        },
        methods: {
            jumpEquity(){
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                console.log(userInfo);
                if(userInfo==''){
                    this.$router.push({
                        path:'/'
                    })
                }
                else{
                    if(userInfo.vipFlag == '0'){
                        toast('请开通会员')
                    }
                    else{
                        this.$router.push({
                            path:'/membershipRights'
                        })
                    }
                }
            },
            switchTab(pathname){
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                if(userInfo==''){
                    this.$router.push({
                        path:'/'
                    })
                }
                let menuList = this.menuList;
                for (let i = 0; i < menuList.length; i++) {
                    let nowItem = menuList[i];
                    if (pathname != nowItem.path) {
                        if (nowItem.child) {
                            let nowItemChild = nowItem.child;
                            for (let j = 0; j < nowItemChild.length; j++) {
                                if (nowItemChild[j] == pathname) {
                                    pathname = nowItem.path;
                                    break;
                                }
                            }
                        }
                    }
                }
                this.pathname = pathname
            }
        },
        mounted() {

        },
        created() {
            let pathname = this.pathname;
            this.switchTab(pathname)
        },
        watch: {
            $route(to, from) {
                let pathname = to.path;
                this.switchTab(pathname)
            }
        },

    }
</script>

<style scoped lang="less">
    .userParent {
        width: 100%;
        background: rgba(241, 244, 248, 1);
        padding: 50px 0px;
    }

    .userCommon {
        width: 1334px;
        min-height: 783px;
        background: rgba(251, 252, 252, 1);
        box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
        border-radius: 15px;
        height: auto;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;

        .userCommon_l {
            width: 176px;
            min-height: 783px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            border-radius: 15px 0px 0px 15px;
            height: auto;

            .leftUlcenter {
                margin-top: 40px;

                li {
                    list-style: none;

                    a {
                        padding-left: 29px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        position: relative;

                        img {
                            width: 16px;
                            height: 16px;
                        }

                        .lediv {
                            padding-left: 15px;
                            height: 22px;
                            font-size: 16px;
                            font-weight: 400;
                            color: #101010;
                            line-height: 22px;
                            letter-spacing: 1px;
                            display: flex;
                            flex-direction: column;
                        }

                        .ridiv {
                            padding-left: 31px;
                            height: 20px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #999;
                            line-height: 20px;
                            display: flex;
                            flex-direction: column;
                        }

                        .active_user {
                            width: 56px;
                            height:1px;
                            background:rgba(18,18,16,1);
                            position: absolute;
                            top: 21px;
                            z-index: 0;
                            left: 61px;
                        }

                        .gddiv {
                            position: absolute;
                            z-index: 10;
                        }
                    }

                    &:first-child a img {
                        width: 16px;
                        height: 18px;
                    }

                }
            }
        }

        .userCommon_r {
            flex: 1;
        }
    }
</style>